import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import i18n from '../i18n/i18next';
import { authFetch } from '../lib/authFetch';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSessionId = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);

      if (!match) {
        navigate('/');
        return;
      }

      const sessionId = match[1];

      try {
        const response = await authFetch(`${API}/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error('Failed to create session');
        }

        const data = await response.json();

        // Set cookie
        Cookies.set('session_token', data.session_token, {
          expires: 7,
          path: '/',
          sameSite: 'None',
          secure: true,
        });

        // Apply saved language preference from MongoDB
        const savedLang = data.user?.language_preference;
        if (savedLang && savedLang !== i18n.language) {
          i18n.changeLanguage(savedLang);
          localStorage.setItem('pangaji_language', savedLang);
        }

        // New users (no projects) go to onboarding; returning users go to dashboard
        try {
          const projRes = await authFetch(`${API}/projects`, { credentials: 'include' });
          const projData = await projRes.json();
          const hasProjects = Array.isArray(projData) && projData.length > 0;
          navigate(hasProjects ? '/dashboard' : '/new-project', { state: { user: data.user }, replace: true });
        } catch {
          navigate('/dashboard', { state: { user: data.user }, replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/');
      }
    };

    processSessionId();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-foreground font-mono animate-pulse">
        Authenticating...
      </div>
    </div>
  );
}
